<template>
  <div class="card-detalhes-reclamacao-tecnica">      
    <g-card
    :temCabecalho="false"
    :expansivel="false"
    >
      <div class="header-detalhes-secundario cabecalho-detalhes">
        <div class="header-detalhes-secundario-titulo">
          <g-button
          largura="35px"
          icone="icone_voltar.svg"
          negritoTexto
          tamanhoIcone="10px"
          cor="#FFFFFF"
          altura="30px"
          :sombreado="false"
          @click="retornaTelaReclamacoesTecnicas"
          />
          <div class="titulo-detalhes-cabecalho "> Detalhes da Reclamação - {{DetalhesReclamacao.codigoReclamacao}} </div>
        </div>
        <div class="header-imprimir">
          <g-button
          largura="38px"
          altura="36px"
          negritoTexto
          tamanhoIcone="18px"
          icone="icone_print.svg"
          v-on:acao="imprimir"
          />
        </div>
      </div>

      <div class="conteudo-card-detalhes-reclamacao-tecnica espacamento-detalhes">
        <div class="grupo-dados-produto topico-conteudo">
          <div class="dados-unidade">
            <div class="titulo-conteudo-detalhes"> Unidade </div>
            <div class="label-conteudo">{{DetalhesReclamacao.nomeEmpresa}}</div>
          </div>

          <div class="dados-codigo-cliente">
            <div class="titulo-conteudo-detalhes"> Código do Cliente </div>
            <div class="label-conteudo">{{DetalhesReclamacao.codigoCliente}}</div>
          </div>

          <div class="dados-cnpj">
            <div class="titulo-conteudo-detalhes"> CNPJ </div>
            <div class="label-conteudo">{{MascaraCnpj}}</div>
          </div>

          <div class="dados-razao-social">
            <div class="titulo-conteudo-detalhes"> Razão Social </div>
            <div class="label-conteudo">{{DetalhesReclamacao.razaoSocial}}</div>
          </div>

          <div class="dados-numero-pedido">
            <div class="titulo-conteudo-detalhes"> Nº Pedido </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroPedido}}</div>
          </div>

          <div class="dados-numero-parcela">
            <div class="titulo-conteudo-detalhes"> Nº Parcela </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroParcela}}</div>
          </div>

          <div class="dados-ordem-servico">
            <div class="titulo-conteudo-detalhes"> Ordem de Serviço </div>
            <div class="label-conteudo">{{DetalhesReclamacao.numeroOrdemServico}}</div>
          </div>

          <div class="dados-numero-notaFiscal">
            <div class="titulo-conteudo-detalhes"> Nota Fiscal </div>
            <div class="label-conteudo">{{DetalhesReclamacao.notaFiscal ? DetalhesReclamacao.notaFiscal : '--'}}</div>
          </div>

          <div class="dados-quantidade">
            <div class="titulo-conteudo-detalhes"> Quantidade com problema </div>
            <div class="label-conteudo">{{DetalhesReclamacao.quantidadeComProblema}}</div>
          </div>

          <div class="dados-nome-atendente">
            <div class="titulo-conteudo-detalhes"> Atendente </div>
            <div class="label-conteudo">{{DetalhesReclamacao.nomeAtendente ? DetalhesReclamacao.nomeAtendente : '--'}}</div>
          </div>

          <div class="dados-data-baixa">
            <div class="titulo-conteudo-detalhes"> Data da Baixa </div>
            <div class="label-conteudo">{{DetalhesReclamacao.dataDaBaixaFormatada}}</div>
          </div>
          
          <div class="dados-descricao-problema">
            <div class="titulo-conteudo-detalhes"> Descrição do problema (Mínimo: 10 caracteres) </div>                        
            <div class="label-conteudo">
              <PTextArea class="text-area-conteudo" v-model="DetalhesReclamacao.descricaoProblema" rows="4" cols="30" disabled></PTextArea>
            </div>
          </div>
          
          <div class="porcentagem-amostra">
            <div class="dados-porcentagem-concluida">
              <div class="titulo-conteudo-detalhes"> Progresso </div>
              <div class="porcentagem-concluida">
                <PProgressBar :value="DetalhesReclamacao.porcentagemConcluida"/>
              </div>
            </div>
            
            <div class="dados-acompanha-amostra">
              <div class="dados-checkbox">
                <div class="acompanha-amostra input-checkbox">
                  <PCheckBox id="acompanha-amostra" class="checkbox-consultas" :binary="true" :value="true" v-model="AcompanhaAmostra" disabled></PCheckBox>
                  <label class="acompanhaAmostra label-checkbox" for="acompanha-amostra"> Acompanha Amostra? </label>
                </div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </g-card>
  </div>
  <g-pdf
    :pdfFloat="false"
    :NovaGuia="true"
    :executar="executarvisualizacao"
  >
    <div class="render" v-if="renderiza">
      <ReclamacaoTecnicaComercialPDF
        :tituloDetalhes="false"
        v-on:termino="gerarPdf"
        :reclamacaoTecnicaSelecionada="ReclamacaoTecnicaId"
      >
      </ReclamacaoTecnicaComercialPDF>
    </div>
  </g-pdf>
</template>

<script>
import DetalhesReclamacaoTecnica from './DetalhesReclamacaoTecnica.js' 
export default DetalhesReclamacaoTecnica
</script>

<style scoped>
.porcentagem-concluida {
  margin-top: 5px;
}

.porcentagem-amostra {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.text-area-conteudo {
  width: 100%;
  margin-top: 5px;
}

.cabecalho-detalhes {
  margin-bottom: 20px;
}

@media(min-width:310px) {
.header-imprimir {
  display: none;
}

.grupo-dados-produto {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(10, auto);
  grid-column-gap: 20px;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-codigo-cliente { grid-area: 2 / 1 / 3 / 3; }
.dados-cnpj { grid-area: 3 / 1 / 4 / 3; }
.dados-razao-social { grid-area: 4 / 1 / 5 / 3; }
.dados-numero-pedido { grid-area: 5 / 1 / 6 / 2; }
.dados-numero-parcela { grid-area: 5 / 2 / 6 / 3; }
.dados-ordem-servico { grid-area: 6 / 1 / 7 / 3; }
.dados-numero-notaFiscal { grid-area: 7 / 1 / 8 / 3; }
.dados-quantidade { grid-area: 8 / 1 / 9 / 3; }
.dados-nome-atendente { grid-area: 9 / 1 / 10 / 3; }
.dados-data-baixa { grid-area: 10 / 1 / 11 / 3; }
.dados-descricao-problema { grid-area: 11 / 1 / 12 / 3; }
.porcentagem-amostra { grid-area: 12 / 1 / 13 / 3; }
}

@media(min-width:400px) {
.header-imprimir {
  display: block;
}
}

@media(min-width:500px) {
.grupo-dados-produto {
  grid-template-rows: repeat(9, auto);
}

.dados-codigo-cliente { grid-area: 2 / 1 / 3 / 2; }
.dados-cnpj { grid-area: 2 / 2 / 3 / 3; }
.dados-razao-social { grid-area: 3 / 1 / 4 / 3; }
.dados-numero-pedido { grid-area: 4 / 1 / 5 / 2; }
.dados-numero-parcela { grid-area: 4 / 2 / 5 / 3; }
.dados-ordem-servico { grid-area: 5 / 1 / 6 / 2; }
.dados-numero-notaFiscal { grid-area: 5 / 2 / 6 / 3; }
.dados-quantidade { grid-area: 6 / 1 / 7 / 2; }
.dados-data-baixa { grid-area: 6 / 2 / 7 / 3; }
.dados-nome-atendente { grid-area: 7 / 1 / 8 / 2; }
.dados-descricao-problema { grid-area: 8 / 1 / 9 / 3; }
.porcentagem-amostra { grid-area: 9 / 1 / 10 / 3; }
}


@media(min-width:600px) {

}

@media(min-width:801px) {
.grupo-dados-produto {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(6, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 2; }
.dados-codigo-cliente { grid-area: 1 / 2 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 4; }
.dados-razao-social { grid-area: 2 / 1 / 3 / 3; }
.dados-numero-pedido { grid-area: 2 / 3 / 3 / 4; }
.dados-numero-parcela { grid-area: 3 / 1 / 4 / 2; }
.dados-ordem-servico { grid-area: 3 / 2 / 4 / 3; }
.dados-numero-notaFiscal { grid-area: 3 / 3 / 4 / 4; }
.dados-quantidade { grid-area: 4 / 1 / 5 / 2; }
.dados-data-baixa { grid-area: 4 / 2 / 5 / 3; }
.dados-nome-atendente { grid-area: 4 / 3 / 5 / 4; }
.dados-descricao-problema { grid-area: 5 / 1 / 6 / 4; }
.porcentagem-amostra { grid-area: 6 / 1 / 7 / 4; }
}

@media(min-width:1025px) {
.dados-razao-social { grid-area: 2 / 1 / 3 / 2; }
.dados-numero-pedido { grid-area: 2 / 2 / 3 / 3; }
.dados-numero-parcela { grid-area: 2 / 3 / 3 / 4; }
.dados-ordem-servico { grid-area: 3 / 1 / 4 / 2; }
.dados-numero-notaFiscal { grid-area: 3 / 2 / 4 / 3; }
.dados-quantidade { grid-area: 3 / 3 / 4 / 4; }
.dados-data-baixa { grid-area: 4 / 1 / 5 / 2; }
.dados-nome-atendente { grid-area: 4 / 2 / 5 / 3; }
.dados-descricao-problema { grid-area: 5 / 1 / 6 / 4; }
.porcentagem-amostra { grid-area: 6 / 1 / 7 / 3; }
}

@media(min-width:1285px) {
.grupo-dados-produto {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
}

.dados-razao-social { grid-area: 1 / 4 / 2 / 5; }
.dados-numero-pedido { grid-area: 2 / 1 / 3 / 2; }
.dados-numero-parcela { grid-area: 2 / 2 / 3 / 3; }
.dados-ordem-servico { grid-area: 2 / 3 / 3 / 4; }
.dados-numero-notaFiscal { grid-area: 2 / 4 / 3 / 5; }
.dados-quantidade { grid-area: 3 / 1 / 4 / 2; }
.dados-nome-atendente { grid-area: 3 / 2 / 4 / 3; }
.dados-data-baixa { grid-area: 3 / 3 / 4 / 4; }
.dados-descricao-problema { grid-area: 4 / 1 / 5 / 4; }
.porcentagem-amostra { grid-area: 5 / 1 / 6 / 3; }
}

@media(min-width:1500px) {
:deep(.p-progressbar) {
  width: 80%;
}

.grupo-dados-produto {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
}

.dados-numero-pedido { grid-area: 1 / 5 / 2 / 6; }
.dados-numero-parcela { grid-area: 1 / 6 / 2 / 7; }
.dados-ordem-servico { grid-area: 2 / 1 / 3 / 2; }
.dados-numero-notaFiscal { grid-area: 2 / 2 / 3 / 3; }
.dados-quantidade { grid-area: 2 / 3 / 3 / 4; }
.dados-nome-atendente { grid-area: 2 / 4 / 3 / 5; }
.dados-data-baixa { grid-area: 2 / 5 / 3 / 6; }
.dados-descricao-problema { grid-area: 3 / 1 / 4 / 5; }
.porcentagem-amostra { grid-area: 4 / 1 / 5 / 4; }
}

@media(min-width:1600px) {
  :deep(.p-progressbar) {
    width: 80%;
  }


}

@media(min-width:1800px) {
  :deep(.p-progressbar) {
    width: 65%;
  }
}
</style>
